module.exports = __webpack_public_path__ + "static/media/bus-icon-map.d2ad8ed3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/bus-icon-map.svg
// module id = 768
// module chunks = 0